import script from "./template3.vue?vue&type=script&setup=true&lang=js"
export * from "./template3.vue?vue&type=script&setup=true&lang=js"

import "./template3.vue?vue&type=style&index=0&id=14355cfa&lang=less"

const __exports__ = script;

export default __exports__